import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';

import styles from './DescriptorList.scss';
import DescriptorEditor from 'indexDocuments/components/DescriptorEditor/DescriptorEditor';
import descriptorPropType from 'indexDocuments/util/descriptorPropType';

class DescriptorList extends Component {
    prepareDescriptors() {
        const { descriptors } = this.props;
        return lodash
            .chain(descriptors)
            .sortBy('order')
            .values()
            .value();
    }

    render() {
        const { documentTypesVisibility } = this.props;
        if (documentTypesVisibility) {
            return <div />;
        }
        const descriptors = this.prepareDescriptors();
        const renderedDescriptors = lodash.map(descriptors,
            ({ descriptor, values, setupValues, singleValueDescriptorValues, ...editorProps }) => {
                return <DescriptorEditor key={descriptor.id}
                    descriptor={descriptor}
                    {...editorProps}
                    values={values}
                    setupValues={setupValues}
                    singleValueDescriptorValues={singleValueDescriptorValues}/>;
            });
        return (
            <div className={styles.descriptorList} data-cy="DescriptorList">
                {renderedDescriptors}
            </div>
        );
    }
}

DescriptorList.propTypes = {
    documentTypesVisibility: PropTypes.bool.isRequired,
    descriptors: PropTypes.objectOf(descriptorPropType)
};

export default DescriptorList;
